import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ApiService } from './api.service';
import 'rxjs/add/operator/map';

@Injectable()
export class CaregiverService {

  constructor(
    private apiService: ApiService
  ) { }

  getCaregivers(): Observable<any> {
    return this.apiService.get('/user/showCaregiver');
  }

  getCaregiver(id): Observable<any> {
    return this.apiService.get(`/user/showCaregiver/${id}`);
  }

  addCaregiver(data): Observable<any> {
    return this.apiService.post('/user/createCaregiver', data);
  }

  editCaregiver(caregiver): Observable<any> {
    return this.apiService.put(`/user/updateCaregiver/${caregiver.id}`, caregiver);
  }

  deleteCaregiver(id): Observable<any> {
    return this.apiService.delete(`/manager/caregiver/${id}`);
  }

  workHours(data): Observable<any> {
    return this.apiService.post('/manager/caregiver/work-hours', data);
  }

  careHours(data): Observable<any> {
    return this.apiService.post('/manager/care-hours', data);
  }

  assignUser(data): Observable<any> {
    return this.apiService.post('/manager/assign-patient-to-caregiver', data);
  }

  assignAllUser(data): Observable<any> {
    return this.apiService.post('/manager/assign-all-patient-to-caregiver', data);
  }

  deleteUser(data): Observable<any> {
    return this.apiService.delete('/manager/remove-patient-from-caregiver', data);
  }

  tempFinishAlarm(data): Observable<any> {
      return this.apiService.post('/alarm/tempFinish', data);
  }


  finishAlarm(data): Observable<any> {
    return this.apiService.post('/alarm/finish', data);
  }


  getCaregiverToAssignProject(id): Observable<any> {
    return this.apiService.get(`/manager/available-caregivers-to-assign-project/${id}`);
  }

  getCaregiverAssignedToProject(id): Observable<any> {
    return this.apiService.get(`/manager/caregivers-assigned-to-project/${id}`);
  }


  assignCaregiver(data): Observable<any> {
    return this.apiService.post('/manager/assign-caregiver-to-project', data);
  }

  deleteCaregiverFromProject(data): Observable<any> {
    return this.apiService.post('/manager/delete-caregiver-from-project', data);
  }

  generateReport(type, form): Observable<any> {
    return this.apiService.post(`/manager/generateReport/${type}`, form);
  }

  generateAlarmReport(form): Observable<any> {
    return this.apiService.get(`/alarmReportPerProject`, form);
  }

  getCalendarEvents(): Observable<any> {
    return this.apiService.get(`/manager/getCalendarEvents`);
  }

  getCalendarUsers(): Observable<any> {
    return this.apiService.get(`/manager/getCalendarUsers`);
  }

  addCalendarEvent(data): Observable<any> {
    return this.apiService.post(`/manager/addCalendarEvent`, data);
  }

  removeCalendarEvent(id): Observable<any> {
    return this.apiService.delete(`/manager/removeCalendarEvent/${id}`);
  }

  getOtherSoses(imei): Observable<any> {
    return this.apiService.get(`/getAllAlarmsNotHandled/${imei}`);
  }

  setPermissions(data): Observable<any> {
    return this.apiService.post('/manager/setPermissions', data);
  }

  getSwitchUsers(): Observable<any> {
    return this.apiService.get(`/manager/getSwitchUsers`);
  }

  getTelecare(): Observable<any> {
    return this.apiService.get(`/manager/getTelecare`);
  }

  startTelecare(formValue, secondLine): Observable<any> {
    return this.apiService.post(`/manager/startTelecare`, { value: formValue, secondLine: secondLine });
  }

  setTelecare(value, seat = -1): Observable<any> {
    return this.apiService.post(`/manager/setTelecare`, {value: value, seat: seat});
  }

  getCaregiverCaregivers(): Observable<any> {
    return this.apiService.get(`/manager/getCaregiverCaregivers`);
  }

  getAllTelecareCaregivers(): Observable<any> {
    return this.apiService.get(`/manager/getAllTelecareCaregivers`);
  }

  getAllRecordings(): Observable<any> {
    return this.apiService.get(`/manager/getAllRecordings`);
  }

  getAllCallQueue(): Observable<any> {
    return this.apiService.get(`/manager/getAllCallQueue`);
  }

  downloadFromS3(name): Observable<any> {
    return this.apiService.get(`/manager/downloadFromS3/${name}`);
  }

  getCallInProgress(): Observable<any> {
    return this.apiService.get(`/manager/getCallInProgress`);
  }

  removeFromCall(carePhone, phoneNumber): Observable<any> {
    return this.apiService.post(`/manager/removeFromCall`, { carePhone: carePhone, phoneNumber: phoneNumber });
  }

  endCall(carePhone): Observable<any> {
    return this.apiService.delete(`/manager/endCall`, { carePhone: carePhone, time: 1 });
  }

  getCaregiverCalls(): Observable<any> {
    return this.apiService.get(`/manager/getCaregiverCalls`);
  }

  addNoteToCall(callId, note): Observable<any> {
    return this.apiService.post(`/manager/addNoteToCall`, { callId: callId, note: note });
  }

  handleGuestCall(data, phoneNumber, callHistoryId, date): Observable<any> {
    return this.apiService.post(`/manager/handleGuestCall`, { data: data, phoneNumber: phoneNumber, callHistoryId: callHistoryId, date: date });
  }

  getCaretakers(id, page, count): Observable<any> {
    return this.apiService.get(`/user/getCaretakers/${id}/${page}/${count}`);
  }

  removeFromQueue(phoneNumber): Observable<any> {
    return this.apiService.delete(`/manager/removeFromQueue/${phoneNumber}`);
  }

  checkIfHandler(type, alarmId): Observable<any> {
    return this.apiService.post(`/manager/checkIfHandler`, { type: type, alarmId: alarmId });
  }

  getGuestAlarm(id): Observable<any> {
    return this.apiService.get(`/manager/getGuestAlarm/${id}`);
  }

  getUserHistory(): Observable<any> {
    return this.apiService.get(`/manager/getUserHistory`);
  }

  //IVR

  getIVRSettings(imei): Observable<any> {
    return this.apiService.get(`/getIVRSettings/${imei}`);
  }

  updateIVRSettings(ivrSetting: any): Observable<any> {
    return this.apiService.put(`/editIVRSettings/${ivrSetting.band_imei}`, {
      inactive: ivrSetting.inactive,
      notWorn: ivrSetting.not_worn,
      custom: ivrSetting.custom,
      idOfFile: ivrSetting.id_of_file,
    });
  }
  getAllCustomIVRSettings(): Observable<any> {
    return this.apiService.get('/getAllCustomIVRSettings');
  }
  
  getAlarmsWithConnected(offset: number = 0, limit: number = 120, selectedOptionFilter): Observable<any> {
    return this.apiService.get(`/manager/getAlarmsWithConnected?offset=${offset}&limit=${limit}&selectedOptionFilter=${selectedOptionFilter}`);
}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/caregiver.service.ts